import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalAlertComponent } from '../app/global-alert/global-alert.component'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,GlobalAlertComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Monitori';
}
